"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Box } from "@mui/material";
import { Text } from "@nxt-costco-com/forge-components";
import { useCheckScreen } from "../../../hooks/useCheckScreen/index.js";
import { SwatchButton } from "./SwatchButton/index.js";
import { SwatchIcon } from "./SwatchButtonOverflowCounter/index.js";
import { COMPONENT_NAME } from "./constants.js";
import { rootContainerStyles, toggleButtonGroupStyles } from "./styles.js";
const ProductSwatch = ({
  onRemovePreview,
  onPreview,
  onSelect,
  outOfStockText = "out of stock",
  moreOptionsText = "more options available",
  swatches = [],
  variant = "full",
  uniqueId,
  sx,
  ariaDescribedBy = "",
  showLabel = true
}) => {
  var _a;
  const [selectedSwatch, setSelectedSwatch] = useState(swatches[0]);
  const [onPreviewSwatch, setOnPreviewSwatch] = useState(
    {}
  );
  const { isMobile } = useCheckScreen();
  const swatchMaxCount = isMobile ? 3 : 4;
  let visibleSwatches = swatches;
  let overflowedSwatches = [];
  const overflowCount = swatches.length - swatchMaxCount;
  const showOverflow = variant === "compact" && swatches.length > swatchMaxCount;
  const computedSx = { ...rootContainerStyles, ...sx };
  if (showOverflow) {
    visibleSwatches = swatches.slice(0, swatchMaxCount);
    overflowedSwatches = swatches.slice(-overflowCount);
  }
  return /* @__PURE__ */ jsxs(Box, { "data-testid": `${COMPONENT_NAME}_${uniqueId}`, sx: computedSx, children: [
    /* @__PURE__ */ jsxs(Box, { sx: toggleButtonGroupStyles, children: [
      visibleSwatches.map((swatch) => {
        const selectedFlag = selectedSwatch.id === swatch.id;
        return /* @__PURE__ */ jsx(
          SwatchButton,
          {
            onBlur: () => {
              setOnPreviewSwatch({});
              if (onRemovePreview) onRemovePreview();
            },
            onClick: () => {
              setSelectedSwatch(swatch);
              onSelect(swatch);
            },
            onFocus: () => {
              setOnPreviewSwatch(swatch);
              if (onPreview) onPreview(swatch);
            },
            onMouseEnter: () => {
              setOnPreviewSwatch(swatch);
              if (onPreview) onPreview(swatch);
            },
            onMouseLeave: () => {
              setOnPreviewSwatch({});
              if (onRemovePreview) onRemovePreview();
            },
            ariaDescribedBy,
            outOfStockText,
            productSwatch: swatch,
            selected: selectedFlag,
            variant
          },
          swatch.id
        );
      }),
      showOverflow && /* @__PURE__ */ jsx(
        SwatchIcon,
        {
          pdpNavigationUrl: (_a = overflowedSwatches[0]) == null ? void 0 : _a.pdpNavigationUrl,
          moreOptionsText,
          overflowCount
        }
      )
    ] }),
    showLabel && /* @__PURE__ */ jsxs(Text, { color: "default", component: "p", variant: "t7", children: [
      selectedSwatch == null ? void 0 : selectedSwatch.label,
      ": ",
      /* @__PURE__ */ jsx(
        Text,
        {
          bold: true,
          color: "default",
          component: "span",
          variant: "t7",
          children: (onPreviewSwatch == null ? void 0 : onPreviewSwatch.attributeValue) || (selectedSwatch == null ? void 0 : selectedSwatch.attributeValue)
        }
      )
    ] })
  ] });
};
ProductSwatch.displayName = COMPONENT_NAME;
export {
  ProductSwatch
};
